import React, { createContext, useEffect, useRef, useState, useMemo } from 'react';
import { flushSync } from 'react-dom';

const LocalContext = createContext();

function LocalContextProvider(props) {
  const [cartCounter, setCartCounter] = useState(0);
  const [quote, setQuote] = useState([]);
  const [initialRender, setInitialRender] = useState(true);
  const [userHasScrolled, setUserHasScrolled] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const counterRef = useRef();
  const cartCounterDummyRef = useRef();

  const dialogAnimationTime = 300;

  useEffect(() => {
    setInitialRender(false);

    const handleScroll = () => {
      setUserHasScrolled(window.scrollY >= 110);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const updateCartCounter = async (quantity) => {
    if (document.startViewTransition) {
      counterRef.current.style.viewTransitionName = 'cart-counter';

      const incrementCounterTransition = document.startViewTransition(() =>
        flushSync(() => setCartCounter(quantity))
      );

      await incrementCounterTransition.finished;

      counterRef.current.style.viewTransitionName = 'none';
    } else {
      flushSync(() => setCartCounter(quantity));
    }
  };

  useEffect(() => {
    if (counterRef.current) {
      const result = window.localStorage.getItem('connollyStairsCart');

      if (result) {
        const _quote = JSON.parse(result);

        if (_quote) {
          setQuote(_quote);
        }

        const _quantity = _quote?.reduce((acc, item) => {
          const sum = acc + (item?.quantity ?? 0);
          return sum;
        }, 0);

        if (_quantity) {
          updateCartCounter(_quantity);
        }
      }
    }
  }, [counterRef]);

  useEffect(() => {
    if (!initialRender) {
      window.localStorage.setItem('connollyStairsCart', JSON.stringify(quote));
    }
  }, [quote]);

  const handleDialog = ({ dialogRef, animation, stateHandler, callback }) => {
    dialogRef.current.setAttribute('data-state', animation);
    dialogRef.current.children[0].setAttribute('data-state', animation);

    stateHandler();

    if (callback) {
      setTimeout(() => callback(), dialogAnimationTime);
    }
  };

  const value = useMemo(
    () => ({
      userHasScrolled,
      cartCounter,
      setCartCounter,
      counterRef,
      cartCounterDummyRef,
      quote,
      setQuote,
      handleDialog,
      dialogAnimationTime,
      showMobileMenu,
      setShowMobileMenu,
      initialRender
    }),
    [
      userHasScrolled,
      cartCounter,
      counterRef,
      cartCounterDummyRef,
      quote,
      handleDialog,
      dialogAnimationTime,
      showMobileMenu,
      initialRender
    ]
  );

  return <LocalContext.Provider value={value}>{props.children}</LocalContext.Provider>;
}

export { LocalContextProvider, LocalContext };
export default LocalContext;
